import { Component } from "react";

import filterTable from "../services/filtering";
import orderTable from "../services/sorting";
import pagination from "../services/pagination";

import ColumnSelection from "../containers/Column.Selections";
import TableHeader from "../containers/Header";
import TableHeaderFilters from "../containers/Header.Filter";
import TableRow from "../containers/Row";
import TablePagination from "../containers/Pagination";
import TableSummary from "./Table.Summary";
import PropTypes from "prop-types";

import "./Table.scss";

class TableComponent extends Component {
  constructor(props) {
    super(props);

    // scrollProgress is for the horizontal scrolling in the table
    this.state = { colPanel: "hidden", scrollProgress: 0 };
  }

  componentDidMount() {
    let { tableKey } = this.props;
    let selections = {};

    if (tableKey && localStorage.getItem(tableKey)) {
      selections = JSON.parse(localStorage.getItem(tableKey));
    }

    this.props.setUpTable(this.props, selections);

    // set the scroller element so we have control while user is scroling
  }

  componentWillUnmount() {
    if (this.scroller)
      this.scroller.removeEventListener("scroll", this.scrollHandler);
  }

  scrollHandler = () => {
    this.setState({ scrollProgress: this.scroller.scrollLeft });
  };

  render() {
    if (!this.props.tables[this.props.tableKey])
      return (
        <div className="relative-container">
          {
            // eslint-disable-next-line react/no-string-refs
            <div className="table-wrapper" ref="theTableWrap" />
          }
        </div>
      );

    let { items, tables, tableKey } = this.props;
    items = items || [];

    let tableInfo = tables[tableKey];
    let filteredItems = filterTable(items, tableInfo);
    let filterdAndOrdered = orderTable(filteredItems, tableInfo);
    let page = pagination(filterdAndOrdered, tableInfo);

    let aboveTebleContent = this.props.aboveContentRenderer
      ? this.props.aboveContentRenderer(this.getSelected, items, this.props)
      : undefined;
    let belowTebleContent = this.props.belowContentRenderer
      ? this.props.belowContentRenderer(this.getSelected, items, this.props)
      : undefined;

    return (
      <div className="relative-container">
        {
          // eslint-disable-next-line react/no-string-refs
          <div className="table-wrapper" ref="theTableWrap">
            {aboveTebleContent}
            <ColumnSelection tableKey={tableKey} />
            {
              // eslint-disable-next-line react/no-string-refs
              <div ref="container">
                {
                  // eslint-disable-next-line react/no-string-refs
                  <table className="react-table" ref="theTable">
                    <thead id="selectToApprove" className="react-table-header">
                      <TableHeader {...this.props} />

                      <TableHeaderFilters {...this.props} />
                    </thead>
                    {items.length == 0 ? (
                      <tbody>
                        <tr>
                          <td
                            colSpan={4}
                            style={{ padding: "20px", textAlign: "center" }}
                          >
                            No Data
                          </td>
                        </tr>
                      </tbody>
                    ) : undefined}
                    {page.map((item, itemIndex) => {
                      if (!item) return <div key={item.Id} />;
                      let keyValue = tableKey + "-" + itemIndex + "-" + item.Id;
                      return (
                        <TableRow
                          {...this.props}
                          item={item}
                          key={tableKey + "-" + itemIndex}
                          keyValue={keyValue}
                          className={
                            (itemIndex % 2 ? "odd-row" : "even-row") +
                            " table-row"
                          }
                        />
                      );
                    })}
                    <TableSummary
                      {...this.props}
                      itemsFiltered={filterdAndOrdered}
                    />
                  </table>
                }
              </div>
            }
            {belowTebleContent}
          </div>
        }
        <TablePagination
          tableKey={tableKey}
          itemsCount={filterdAndOrdered.length}
        />
      </div>
    );
  }

  getSelected = () => {
    let { tableKey, selectId, tables, items } = this.props;
    let selectionsNew = {};
    let selectedArray = [];

    for (var i = 0; i < items.length; i++) {
      var element = items[i];
      if (tables[tableKey].selections[element[selectId]]) {
        selectedArray.push(element);
        selectionsNew[element[selectId]] = true;
      }
    }

    localStorage.setItem(tableKey, JSON.stringify(selectionsNew));
    return selectedArray;
  };

  static propTypes = {
    columns: PropTypes.array.isRequired,
    items: PropTypes.array.isRequired,
    tables: PropTypes.object.isRequired,
    // options
    actionColumnWidth: PropTypes.number,

    //selections
    selectId: PropTypes.string,
    tableKey: PropTypes.string.isRequired,

    //additional renders
    aboveContentRenderer: PropTypes.func,
    belowContentRenderer: PropTypes.func,
  };
}

export default TableComponent;
